const beginLazyLoading = (prevState, action) => {
  const treeState = prevState[action.treeId];
  const { lazyLoading } = action.plugins;

  if (!lazyLoading) {
    return prevState;
  }

  return {
    ...prevState,
    [action.treeId]: lazyLoading.handleBeginLazyLoading(treeState, action),
  };
};
export default beginLazyLoading;
